import { useEffect } from 'react';

interface UseBenefitsManagementProps {
  isOccasionalEngagement: boolean;
  engagementType: string;
  pensionValue: boolean;
  holidaySavings: boolean;
  setValue: (field: string, value: any) => void;
  setPensionPay: (value: boolean) => void;
  setHolidayPay: (value: boolean) => void;
}

export const useBenefitsManagement = ({
  isOccasionalEngagement,
  engagementType,
  pensionValue,
  holidaySavings,
  setValue,
  setPensionPay,
  setHolidayPay
}: UseBenefitsManagementProps) => {
  
  // Auto-uncheck pension and holiday savings if engagement type changes to occasional
  useEffect(() => {
    if (isOccasionalEngagement) {
      // If engagement type is occasional, uncheck and disable pension/holiday
      if (pensionValue) {
        setValue('pension', false);
        setPensionPay(false);
      }
      if (holidaySavings) {
        setValue('holidaySavings', false);
        setHolidayPay(false);
      }
    }
  }, [engagementType, isOccasionalEngagement, pensionValue, holidaySavings, setValue, setPensionPay, setHolidayPay]);
};
